import { useCallback, useEffect, useState } from "react";

import { api_without_cancellation } from "../../../api/api";
import { getCaseId } from "../../../Utils/helper";

export const useDocumentDrafts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDrafts = useCallback(async (showLoading = true) => {
    if (showLoading) {
      setLoading(true);
    }
    setError(null);

    try {
      const res = await api_without_cancellation.get(
        "/api/documents/document-drafts-for-doc-draft-page/",
        {
          params: {
            case_id: getCaseId(),
            // client_id: getClientId(),
          },
        }
      );

      if (res.status !== 200) {
        throw new Error("Failed to fetch document drafts");
      }

      setData(res.data);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    fetchDrafts(); // Initial fetch with loading spinner

    // Poll every 30 seconds without showing loading spinner
    const intervalId = setInterval(() => {
      fetchDrafts(false); // Silent refresh
    }, 30000); // 30 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [fetchDrafts]);

  return {
    data,
    loading,
    error,
    refetch: fetchDrafts,
  };
};
